export interface BTechECEProgram {
  name: string;
  description: string;
  hod: string;
  hod_image: string;
  email: string;
}

const bTechECEProgramData: BTechECEProgram = {
  name: "Department of Arts, Science, and Design",
  description:
    "The Department of Arts, Science, and Design (ASD) at IIIT Dharwad offers a unique interdisciplinary approach, integrating creative arts and design thinking with rigorous scientific and technological foundations. We foster innovation, critical thinking, and problem-solving skills, preparing students for diverse careers at the intersection of technology, design, and humanities.",
  hod: "Dr. Aswath Babu H",
  hod_image: "https://www.iiitdwd.ac.in//images/Dr.AswathBabuH.jpeg",
  email: "aswath@iiitdwd.ac.in",
};

export default bTechECEProgramData;
